import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=b92ce0e8&scoped=true"
import script from "./AlertDialog.vue?vue&type=script&lang=ts"
export * from "./AlertDialog.vue?vue&type=script&lang=ts"
import style0 from "./AlertDialog.vue?vue&type=style&index=0&id=b92ce0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92ce0e8",
  null
  
)

export default component.exports